import { createRouter, createWebHistory } from 'vue-router';
import Cookies from 'js-cookie';
import menus from '@/menu/index.js'
import getMenuCookie from '@/menu/getMenuCookie.js'

let menuRaw = localStorage.getItem('menu');
let auth = !!Cookies.get('isAuthenticated');
let menu = null;

if (menuRaw) {
  const parsed = JSON.parse(menuRaw);
  // Pinia persist guarda el estado completo, no solo el array
  menu = parsed.menu ?? parsed; // 👈 maneja ambos casos
}

// let menu = localStorage.getItem('menu');
// let auth = !!Cookies.get('isAuthenticated');

// if(menu){
//   menu = JSON.parse(menu);
//   menu = menu.menu;
// }

// Siempre incluir las rutas iniciales y, si existe menú + auth, agregar las dinámicas
let routes = menus['initial'];
if (menu && auth) {
  routes = [...routes, ...getMenuCookie(menu)];
}
routes.push({path: '/:pathMatch(.*)*', name:'logout', component: () => import('@/shared/views/ErrorView.vue') });

const router = createRouter({
  mode: 'history',
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
});

export const resetRouter = () => {
  router.getRoutes().forEach(route => {
    const routeName = route.name;
    if (routeName) {
      router.removeRoute(routeName);
    }
  });
};

export const addRoutes = (newRoutes) => {
  resetRouter();
  newRoutes.push({path: '/:pathMatch(.*)*', name:'na', component: () => import('@/shared/views/ErrorView.vue') });
  newRoutes.forEach(route => {
    if (!router.hasRoute(route.name)) {
      router.addRoute(route);
      if(route.children && route.children.length){
        route.children.forEach(route_children =>{
          router.addRoute(route_children);
        });
      }
      
    }
  });
};

router.beforeEach((to, from, next) => {
  // console.log('on beforeEach to ', to.fullPath);
  // console.log('on beforeEach from ', from);
  const isAuthenticated = !!Cookies.get('isAuthenticated');

  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    (to.name !== 'login') ? next({ name: 'login' }) : next();
  } else if ((to.path === '/login' || to.path === '/') && isAuthenticated) {
    // Redirigir a la primera ruta protegida del menú dinámico
    try {
      let menuLocal = localStorage.getItem('menu');
      if (menuLocal) {
        menuLocal = JSON.parse(menuLocal);
        const dynamicRoutes = getMenuCookie(menuLocal.menu ? menuLocal.menu : menuLocal);
        const target = dynamicRoutes.find(r => r?.meta?.requiresAuth && r.path && r.path !== '/' && r.path !== '/login');
        if (target) {
          return next({ path: target.path });
        }
      }
    } catch (e) { console.warn('beforeEach redirect error', e); }
    next();
  } else {
    next();
  }
});

export default router
